import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Slider from 'react-slick';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { pressContent } from '../../data/mock';

gsap.registerPlugin(ScrollTrigger);

const Press = () => {
  const sectionRef = useRef(null);
  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.press-animate',
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 60%',
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="py-32 bg-[#0B1121]">
      <div className="l-container">
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 mb-16">
          <div className="press-animate">
            <p className="sub-title">{pressContent.label}</p>
            <h2 className="big-title">{pressContent.title}</h2>
          </div>

          {/* Navigation */}
          <div className="flex gap-4 press-animate">
            <button
              onClick={() => sliderRef.current?.slickPrev()}
              className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#4ECDC4] hover:text-[#4ECDC4] transition-colors"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={() => sliderRef.current?.slickNext()}
              className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#4ECDC4] hover:text-[#4ECDC4] transition-colors"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        {/* Slider */}
        <div className="press-animate -mx-4">
          <Slider ref={sliderRef} {...sliderSettings}>
            {pressContent.articles.map((article, index) => (
              <div key={index} className="px-4">
                <a
                  href={article.link}
                  className="block group"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="aspect-[4/3] overflow-hidden rounded-lg mb-6">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <p className="text-[#4ECDC4] text-xs uppercase tracking-wider mb-3">
                    {article.source}
                  </p>
                  <h4 className="font-serif text-xl text-white group-hover:text-[#4ECDC4] transition-colors line-clamp-2">
                    {article.title}
                  </h4>
                </a>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Press;
